import { FormikProps } from 'formik';
import { isEmpty, orderBy } from 'lodash';
import React from 'react';

import { IModel } from '../../models/typings';

import CustomFormField from './CustomFormField';
import { FORM_ITEM_DEFAULT_LAYOUT } from './form-fields'

export interface IModelFieldProps {
  formikProps: FormikProps<any>;
  canUpdateRow: boolean;
  isNew: boolean;
  model: IModel;
  typeSchema: any;
}

export const ModelFields: React.FC<IModelFieldProps> = ({
  formikProps,
  canUpdateRow,
  isNew,
  model,
  typeSchema,
}) => {
  const { values } = formikProps;

  const FIELD_WEIGHTS = {
    [model.primaryKey]: 1,
    createdAt: 2,
    updatedAt: 3,
    name: 4,
    unitNumber: 4,
    building: 5,
    type: 6,
    accessTimeout: 7,
    rexAccessTimeout: 7,
  };

  // @TODO: Improve sorting via form options
  const weightedFieldNames = Object.keys(typeSchema).map(fieldName => {
    const weight = FIELD_WEIGHTS[fieldName] || 10;

    return { fieldName, weight };
  });

  const sortedFieldNames = orderBy(weightedFieldNames, f => f.weight, 'asc').map(f => f.fieldName);

  return (
    <>
      {sortedFieldNames.map((fieldName) => {
        if (
          !fieldName.match(/Id/) ||
          model.primaryKey === fieldName ||
          fieldName === 'assignedToAnonymousUserId' ||
          fieldName === 'imageId' ||
          fieldName === 'sourceId'
        ) {
          const field = model.introspection.fields.find(f => f.name === fieldName);

          if (!field || (isNew && !field.canCreate)) {
            return null; // Do not render field for "New" form
          }

          return (
            <CustomFormField
              formikProps={formikProps}
              canUpdateRow={canUpdateRow}
              formItemLayout={FORM_ITEM_DEFAULT_LAYOUT}
              key={fieldName}
              model={model}
              field={field}
              typeSchema={typeSchema}
              isNew={isNew}
            />
          );
        }

        return null;
      })}
      {model.formOptions?.renderExtra && values && !isEmpty(values) ? (
        model.formOptions.renderExtra(formikProps, isNew)
      ) : null}
    </>
  )
}

export default ModelFields;
